export default {
    getInventoryVendors: (state) => state.inventoryVendors,
};
